/* global axios */
import ApiClient from './ApiClient';

class InstagramAutoReplyAPI extends ApiClient {
  constructor() {
    super('instagram_auto_replies', { accountScoped: true });
  }

  testMatch(data) {
    return axios.post(`${this.url}/test_match`, data);
  }
}

export default new InstagramAutoReplyAPI();
